import PropTypes from 'prop-types';
import React from 'react';
import StyledSelect from './select.style';

import { AngleDown } from '../../icons/arrow/arrow';

const Select = ({
  className,
  name,
  label,
  required = false,
  options,
  standalone,
  placeholder,
  canSelectPlaceholder = false,
  defaultValue,
  onChange,
  onFocus,
  onBlur,
  active,
  warning,
  error = false,
  disabled = false
}) => (
  <StyledSelect
    className={`${className || ''} ${standalone ? `select--standalone` : ''}
    }`}
    error={error}
    disabled={disabled}
    active={active}
  >
    <label htmlFor={label} className="select__wrapper">
      <div className="select__label">
        {required && <span className="select__required">*</span>}
        <span className="select__labelText">{label}</span>
      </div>
      <div className="select__inner">
        <select
          id={label}
          name={name}
          defaultValue={defaultValue || placeholder}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          aria-invalid={error}
          aria-required={required}
          disabled={disabled}
        >
          <option value={placeholder} selected={!defaultValue} disabled={!canSelectPlaceholder}>
            {placeholder}
          </option>
          {options?.map(option => (
            <option
              value={option.value}
              key={option.value}
              selected={defaultValue === option.value}
            >
              {option.text}
            </option>
          ))}
        </select>
        <span className="select__icon">
          <AngleDown />
        </span>
      </div>
    </label>

    {warning && (
      <span className="select__warn" aria-hidden={!error}>
        {warning}
      </span>
    )}
  </StyledSelect>
);

Select.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  ).isRequired,
  standalone: PropTypes.bool,
  placeholder: PropTypes.string,
  canSelectPlaceholder: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  active: PropTypes.bool.isRequired,
  warning: PropTypes.shape(),
  error: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Select;
